import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {Regioverantwoordelijke, RegioverantwoordelijkeDto} from './regioverantwoordelijke';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {Page, PageDto} from '../core/pagination/page';
import {PageRequest} from '../core/pagination/page-request';

@Injectable({
  providedIn: 'root'
})
export class RegioverantwoordelijkeService {
  private http = inject(HttpClient);

  getRegioverantwoordelijkeMe$(): Observable<Regioverantwoordelijke> {
    return this.http
      .get<RegioverantwoordelijkeDto>(`${environment.apiUrl}/regioverantwoordelijken/me`)
      .pipe(map(dto => Regioverantwoordelijke.deserialize(dto)));
  }

  getRegioverantwoordelijken$(pageRequest: PageRequest<Regioverantwoordelijke>): Observable<Page<Regioverantwoordelijke>> {
    return this.http
      .post<PageDto<RegioverantwoordelijkeDto>>(`${environment.apiUrl}/regioverantwoordelijken/page`, pageRequest)
      .pipe(map(pageDto => new Page(
        pageDto.ascending,
        pageDto.pageSize,
        pageDto.pageNumber,
        pageDto.lastPage,
        pageDto.items.map(dto => Regioverantwoordelijke.deserialize(dto)),
      )));
  }

  getRegioverantwoordelijkenByIds$(regioverantwoordelijkeIds: Array<{ id: string, nummer: string }>): Observable<Array<Regioverantwoordelijke>> {
    return this.http
      .post<Array<RegioverantwoordelijkeDto>>(`${environment.apiUrl}/regioverantwoordelijken/ids`, {ids: regioverantwoordelijkeIds.map(id => id.id)})
      .pipe(map(regioverantwoordelijkeDtos => this.getRegioverantwoordelijken(regioverantwoordelijkeIds, regioverantwoordelijkeDtos)));
  }

  private getRegioverantwoordelijken(regioverantwoordelijkeIds: Array<{ id: string, nummer: string }>, regioverantwoordelijkeDtos: Array<RegioverantwoordelijkeDto>): Array<Regioverantwoordelijke> {
    const regioverantwoordelijken = regioverantwoordelijkeDtos.map(dto => Regioverantwoordelijke.deserialize(dto));
    return regioverantwoordelijkeIds.map(regioverantwoordelijkeId =>
        regioverantwoordelijken.find(regioverantwoordelijke => regioverantwoordelijke.hasId(regioverantwoordelijkeId.id))
        || Regioverantwoordelijke.verwijderd(regioverantwoordelijkeId.id, regioverantwoordelijkeId.nummer)
      );
  }

  postRegioverantwoordelijke$(regioverantwoordelijke: Regioverantwoordelijke): Observable<Regioverantwoordelijke> {
    return this.http
      .post<RegioverantwoordelijkeDto>(`${environment.apiUrl}/regioverantwoordelijken`, regioverantwoordelijke)
      .pipe(map(dto => Regioverantwoordelijke.deserialize(dto)));
  }

  getRegioverantwoordelijkeById$(id: string): Observable<Regioverantwoordelijke> {
    return this.http.get<RegioverantwoordelijkeDto>(`${environment.apiUrl}/regioverantwoordelijken/${id}`)
      .pipe(map(dto => Regioverantwoordelijke.deserialize(dto)));
  }

  updateRegioverantwoordelijke$(regioUser: Regioverantwoordelijke): Observable<Regioverantwoordelijke> {
    return this.http
      .put<RegioverantwoordelijkeDto>(`${environment.apiUrl}/regioverantwoordelijken/${regioUser.getId()}`, regioUser)
      .pipe(map(dto => Regioverantwoordelijke.deserialize(dto)));
  }

  deleteRegioverantwoordelijke$(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/regioverantwoordelijken/${id}`);
  }
}
